import { useState } from "react";
import classes from "./AdminLogin.module.css";

export default function AdminLogin({ onLogin }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        try {
            const res = await fetch("/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });
            if (!res.ok) {
                throw new Error("Invalid credentials");
            }
            const data = await res.json();
            onLogin(data.token);
        } catch {
            setError("Invalid username or password.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <h1 className={classes.title}>Admin Login</h1>
            <input
                className={classes.input}
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
            />
            <input
                className={classes.input}
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
            />
            {error && <p className={classes.error}>{error}</p>}
            <button className={classes.button} type="submit" disabled={submitting}>
                {submitting ? "Logging in..." : "Log in"}
            </button>
        </form>
    );
}
